import { useTranslation } from 'react-i18next';

import { constants } from '@hero/configs';
import { AUTOMATION_STATUSES } from '@hero/constants';

function useAutomationTableFilterOptions() {
  const { t } = useTranslation();

  return [
    { label: t('active'), value: AUTOMATION_STATUSES.active },
    { label: t('readyToActivate'), value: AUTOMATION_STATUSES.readyToActivate },
    { label: t('draft'), value: AUTOMATION_STATUSES.draft },
    { label: t('deactivated'), value: AUTOMATION_STATUSES.deactivated }
  ].filter(option => {
    return constants?.automation?.table?.statuses.includes(option.value);
  });
}

export { useAutomationTableFilterOptions };
